<template>
  <div class="page">
    <navbar></navbar>
    <div class="content">
      <div class="kv">
        <span class="key">Appointment ID</span>
        <span class="val">{{ appointment.id }}</span>
      </div>

      <div class="kv">
        <span class="key">Patient Details</span>
        <span class="val">{{ appointment.name }}</span>
        <span class="val no-v-padding">{{ appointment.phone }}</span>
        <span class="val">{{ appointment.email }}</span>
      </div>

      <div class="kv">
        <span class="key">Address & Time</span>
        <span class="val">{{ appointment.address }}</span>
        <span class="val no-v-padding">{{ appointment.city }}</span>
        <span class="val">{{
          moment(appointment.time).format("YYYY-MM-DD , HH:mm a")
        }}</span>
      </div>

      <div class="kv">
        <span class="key" style="margin-bottom: 1rem">Tests</span>
        <span
          class="val item"
          v-for="test in appointment.tests"
          v-bind:key="test.id"
          >- {{ test.name }}</span
        >
      </div>

      <button @click="openLIms">Open LIMS</button>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
import moment from "moment";
export default {
  name: "Detail",
  components: {
    navbar: NavBar,
  },
  data() {
    return {};
  },
  methods: {
    openLIms() {
      let url = `http://portal.nxgenlabs.com.pk:1244/lims/Security/AdminLogin.aspx`;
      window.open(url, "_blank");
    },
  },
  created() {
    this.moment = moment;
    try {
      var appointment;
      if (this.$route.params.appointment) {
        appointment = this.$route.params.appointment;
        localStorage.setItem("appointment", this.$route.params.appointment);
      } else {
        appointment = localStorage.getItem("appointment");
      }

      this.appointment = JSON.parse(appointment);
      console.log(this.appointment);
      console.log(this.appointment.id);
    } catch (error) {
      console.log("Parsing error for appointment");
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 1rem;
  overflow-y: scroll;
}

button {
  margin-top: 2rem;
  border-radius: 0.4rem;
}
.kv {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 0.1rem solid lightgray;
  border-left: 0.1rem solid lightgray;
  border-right: 0.1rem solid lightgray;
  border-radius: 0.4rem;
  overflow: hidden;
  margin-bottom: 1rem;

  .key {
    width: 100%;
    background: #e0e0e0;
    padding: 1rem;
    color: black;
    font-family: "P-500";
    text-transform: uppercase;
    font-size: 1.2rem;
  }

  .val {
    width: 100%;
    background: white;
    padding: 1rem;
    color: black;
    font-family: "P-400";
    font-size: 1.4rem;
  }

  .no-v-padding {
    padding: 0rem 1rem;
  }

  .item {
    padding: 0rem 1rem;
    margin-bottom: 0.5rem;
  }
}
</style>